import * as React from "react";
import { useState } from "react";
import styled from "styled-components"

import FloatingLabel from './FloatingLabel';

const errorColor = "red";

interface IStyleProps {
    margin?: string,
    width?: string
};

const TextInputContainer = styled.div`
    position: relative;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    padding: 0px 10px 0px 10px;
    margin: ${(props: IStyleProps) => props.margin ? props.margin : ""};
    background-color: white;
    &.focused {
        border-color: #333333;
    }
    &.error{
        border-color: ${errorColor};
    }
    width: ${(props: IStyleProps) => props.width};
`;

const InputBox = styled.input`
    line-height: 34px;
    font-size: 1.1rem;
    height: 34px;
    background-color: transparent;
    color: #333333;
    width: 100%;
`;

interface IProps {
    ariaLabel?: string,
    value: string,
    label: string,
    onChange: (e: React.SyntheticEvent<HTMLInputElement>) => void,
    type?: string,
    margin?: string,
    max?: number,
    maxLength?: number,
    min?: number,
    width?: string,
    placeholder?: string,
    invalid?: boolean
};

const TextInput = (props: IProps) => {
    const {
        ariaLabel,
        invalid,
        label,
        margin,
        max,
        maxLength,
        min,
        onChange,
        placeholder,
        value,
        type,
        width
    } = props;

    const [focus, setFocus] = useState(false);
    const reference = React.useRef(null as unknown as any);

    const flagAsFocused = () => {
        if (reference.current != null) {
            reference.current.focus();
        }
        setFocus(true);
    };

    const clearFocus = () => {
        setFocus(false);
    };

    const changeText = (event: React.SyntheticEvent<HTMLInputElement>) => {
        if (!maxLength || event.currentTarget.value.length <= maxLength) {
            onChange(event);
        }
    };

    return <TextInputContainer
        style={invalid ? { borderColor: "red", width } : {width}}
        className={`textInput ${focus && "focused"}`}
        onFocus={flagAsFocused}
        onBlur={clearFocus}
        margin={margin}
    >
        {label && <FloatingLabel className={`${focus && "focused"} ${(focus || value !== "" || placeholder) && "above"}`} onClick={flagAsFocused}>{label}</FloatingLabel>}
        <InputBox
            aria-label={ariaLabel}
            value={value}
            ref={reference}
            onChange={changeText}
            type={type}
            max={max}
            maxLength={maxLength}
            min={min}
            placeholder={placeholder} />
    </TextInputContainer>
}

export default TextInput;


// WEBPACK FOOTER //
// ./src/SharedComponents/TextInput.tsx